<template>

    <div class="py-4 container-fluid">
      <div class="row g-4">
        <div class="col-lg-8">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">{{ user.id ? 'Editar Usuario' : 'Crear Usuario' }}</p>
                <argon-button color="success" size="sm" class="ms-auto" @click="save">
                  Guardar
                </argon-button>
              </div>
            </div>
            <div class="card-body">
              <form autocomplete="off" @submit.prevent>
              <p class="text-uppercase text-sm">Información</p>
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label">
                    Nombre <span v-if="isClient" class="text-danger">*</span>
                  </label>
                  <argon-input type="text"  v-model="user.name"/>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">
                    Teléfono
                    <small v-if="isClient" class="text-muted">(opcional)</small>
                  </label>
                  <argon-input type="text" v-model="user.phone"  autocomplete="off" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">
                    Correo electrónico
                    <small v-if="isClient" class="text-muted">(opcional)</small>
                  </label>
                  <argon-input type="email" v-model="user.email" autocomplete="off"  />
                </div>

                 <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label">
                      Dirección
                      <small v-if="isClient" class="text-muted">(opcional)</small>
                    </label>
                    <argon-input type="text" v-model="user.address" autocomplete="off" />
                  </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">
                    Tipo de Documento
                    <span v-if="isClient" class="text-danger">*</span>
                  </label>
                  <select
                    id="user_document_type"
                    class="form-select"
                    v-model="user.document_type"
                    autocomplete="off"
                  >
                    <option value="">Seleccione un tipo</option>
                    <option value="CC">Cédula de Ciudadanía (CC)</option>
                    <option value="CE">Cédula de Extranjería (CE)</option>
                    <option value="TI">Tarjeta de Identidad (TI)</option>
                    <option value="RC">Registro Civil (RC)</option>
                    <option value="PA">Pasaporte (PA)</option>
                    <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                    <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                  </select>
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">
                    Número de Documento
                    <span v-if="isClient" class="text-danger">*</span>
                  </label>
                  <argon-input
                    id="user_document"
                    name="user_document_number"
                    type="text"
                    v-model="user.document"
                    autocomplete="off"
                  />
                </div>

                <div class="col-md-6">
                  <label for="user_license_plate" class="form-control-label">
                    Placa
                    <small class="text-muted">(opcional)</small>
                  </label>
                  <argon-input
                    id="user_license_plate"
                    type="text"
                    v-model="user.license_plate"
                    placeholder="Ej: ABC123"
                    autocomplete="off"
                  />
                </div>

                <div v-if="!isClient" class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Contraseña</label
                  >
                  <argon-input type="password" v-model="user.password"  autocomplete="off" />
                </div>

                <div v-if="!isClient" class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Confirmar Contraseña</label
                  >
                  <argon-input type="password" v-model="user.password_confirmation" autocomplete="off"  />
                </div>

                <div v-if="!isClient" class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Forma de pago</label
                  >
                  <select id="user_payment" class="form-select" v-model="user.payment" autocomplete="off">
                    <option value="0">Mensualidad</option>
                    <option value="1">Por Tarea</option>
                  </select>
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Cargo</label
                  >
                  <select id="user_role" class="form-select" v-model="user.role" autocomplete="off">
                    <option value="1">Administrador</option>
                    <option value="4">Cliente</option>
                    <option value="5">Proveedor</option>
                    <option value="6">Operador</option>
                  </select>
                </div>

                <div class="col-md-12" hidden>
                  <label for="processes-checkbox-list" class="form-control-label">Procesos</label>
                  <div id="processes-checkbox-list" class="checkbox-grid">
                    <div v-for="process in processes" :key="process.id" >
                      <argon-checkbox 
                        :id="'process-' + process.id" 
                        :value="process.id" 
                        :checked="user.processes.includes(process.id)"
                        v-model="user.processes" 
                      >
                        {{ process.name }}
                      </argon-checkbox>
                    </div>

                  </div>
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Estado</label
                  >
                  <select id="user_status" class="form-select" v-model="user.status" autocomplete="off">
                    <option value="1">Activo</option>
                    <option value="0">Inactivo</option>
                  </select>
                </div>
               
              </div>
              </form>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="card side-photo-card">
            <div class="card-header pb-0">
              <p class="mb-0 text-sm text-uppercase">Foto de moto</p>
              <small class="text-muted">Opcional</small>
            </div>
            <div class="card-body text-center">
              <div class="motorcycle-photo-panel border rounded p-3">
                <div v-if="motorcyclePhotoPreview" class="motorcycle-photo-wrap">
                  <img :src="motorcyclePhotoPreview" alt="Foto de moto" class="motorcycle-photo-preview" />
                </div>
                <div v-else class="motorcycle-photo-empty text-muted">
                  <i class="fas fa-motorcycle fa-2x mb-2 d-block opacity-6"></i>
                  <span class="text-sm">Sin foto cargada</span>
                </div>
              </div>

              <div class="d-grid gap-2 mt-3">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  :disabled="uploadingMotorcyclePhoto"
                  @click="$refs.motorcyclePhotoInput.click()"
                >
                  <i class="fa fa-camera me-1"></i>
                  {{ uploadingMotorcyclePhoto ? 'Subiendo...' : (motorcyclePhotoPreview ? 'Cambiar foto' : 'Subir foto') }}
                </button>
                <button
                  v-if="motorcyclePhotoPreview"
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  @click="clearMotorcyclePhoto"
                >
                  Quitar foto
                </button>
              </div>

              <small v-if="!user.id" class="text-muted d-block mt-3 text-sm">
                La imagen se guardará al crear el usuario.
              </small>

              <input
                ref="motorcyclePhotoInput"
                type="file"
                accept="image/*"
                class="d-none"
                @change="onMotorcyclePhotoSelected"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<style scoped>
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.motorcycle-photo-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.motorcycle-photo-panel {
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
}

.motorcycle-photo-empty {
  padding: 1.5rem 0;
}

.motorcycle-photo-preview {
  width: 100%;
  max-height: 260px;
  border-radius: 8px;
  object-fit: cover;
}

.side-photo-card {
  position: sticky;
  top: 1rem;
}
</style>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import ArgonCheckbox from "../../../components/ArgonCheckbox.vue";
import Swal from 'sweetalert2';
import userService from '@/services/user.service';

const body = document.getElementsByTagName("body")[0];


export default {
  name: "User Create",
  data() {
    return {
      showMenu: false,
      apiUrl: process.env.VUE_APP_API_IMAGE_URL || process.env.VUE_APP_API_BASE_URL,
      uploadingMotorcyclePhoto: false,
      motorcyclePhotoFile: null,
      motorcyclePhotoPreview: '',
      existingMotorcyclePhoto: null,
      user: {
        id:0,
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: '1',
        status: '1',
        phone: '',
        payment: '0',
        processes: [],
        address: '',
        document_type: 'CC',
        document: '',
        license_plate: ''
      },
      processes: [],
    };
  },
  components: { ArgonInput, ArgonButton, ArgonCheckbox },
  computed: {
    isClient() {
      return String(this.user.role) === '4';
    },
  },
  watch: {
    '$route.params.user'() {
      this.loadFromRoute();
    },
  },
  methods: {
    parseProcesses(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      try {
        const parsed = typeof value === 'string' ? JSON.parse(value) : value;
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    },
    applyUserData(params) {
      if (!params?.id) return;

      this.user.id = params.id || 0;
      this.user.name = params.name || '';
      this.user.email = params.email || '';
      this.user.role = String(params.role ?? '1');
      this.user.status = String(params.status ?? '1');
      this.user.phone = params.phone || '';
      this.user.payment = String(params.payment ?? '0');
      this.user.address = params.address || '';
      this.user.document_type = params.document_type ? String(params.document_type) : 'CC';
      this.user.document = params.document != null ? String(params.document) : '';
      this.user.license_plate = params.license_plate || '';
      this.user.processes = this.parseProcesses(params.processes);
      this.user.password = '';
      this.user.password_confirmation = '';

      this.loadMotorcyclePhoto(params.id);
    },
    async loadFromRoute() {
      const raw = this.$route.params.user;
      if (!raw) {
        return;
      }

      try {
        const params = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (!params?.id) return;

        try {
          const response = await userService.getUser(params.id);
          if (response?.data) {
            this.applyUserData(response.data);
            return;
          }
        } catch (error) {
          console.error('Error fetching user details:', error);
        }

        this.applyUserData(params);
      } catch (error) {
        console.error('Error al parsear los datos del usuario:', error);
      }
    },
    async getOficios() {
      this.processes =  await this.$store.dispatch('users/getOficios'); 
    },
    generateRandomClientEmail() {
      const randomHash = Math.random().toString(36).slice(2, 10);
      return `cliente+${randomHash}@mistock.co`;
    },
    mediaUrl(filePath) {
      if (!filePath) return '';
      if (filePath.startsWith('http') || filePath.startsWith('data:')) return filePath;
      return `${this.apiUrl}${filePath}`;
    },
    onMotorcyclePhotoSelected(event) {
      const file = event?.target?.files?.[0];
      if (!file) return;
      this.motorcyclePhotoFile = file;
      this.motorcyclePhotoPreview = URL.createObjectURL(file);
      if (event.target) event.target.value = '';
    },
    clearMotorcyclePhoto() {
      this.motorcyclePhotoFile = null;
      this.motorcyclePhotoPreview = '';
      this.existingMotorcyclePhoto = null;
    },
    async loadMotorcyclePhoto(userId) {
      if (!userId) return;
      try {
        const media = await this.$store.dispatch('media/getData', userId);
        const list = Array.isArray(media?.data) ? media.data : media?.data?.data || [];
        const photos = list.filter((item) => item.mediaable_type === 'user_motorcycle_photo');
        if (photos.length > 0) {
          this.existingMotorcyclePhoto = photos[photos.length - 1];
          this.motorcyclePhotoPreview = this.mediaUrl(this.existingMotorcyclePhoto.file_path);
        }
      } catch (error) {
        console.error('Error loading motorcycle photo:', error);
      }
    },
    async uploadMotorcyclePhoto(userId) {
      if (!userId || !this.motorcyclePhotoFile) return;

      this.uploadingMotorcyclePhoto = true;
      try {
        if (this.existingMotorcyclePhoto?.id) {
          await this.$store.dispatch('media/delete', this.existingMotorcyclePhoto.id);
        }

        const formData = new FormData();
        formData.append('mediaable_id', userId);
        formData.append('mediaable_type', 'user_motorcycle_photo');
        formData.append('file', this.motorcyclePhotoFile);

        const response = await this.$store.dispatch('media/save', formData);
        if (!response || response.status < 200 || response.status >= 300) {
          throw new Error(response?.data?.message || 'Error al subir la foto de moto');
        }

        this.motorcyclePhotoFile = null;
        await this.loadMotorcyclePhoto(userId);
      } finally {
        this.uploadingMotorcyclePhoto = false;
      }
    },
    buildSavePayload() {
      const payload = { ...this.user };

      payload.role = String(payload.role ?? '1');
      payload.payment = String(payload.payment ?? '0');
      payload.status = payload.status === '0' || payload.status === 0 ? 0 : 1;
      payload.license_plate = payload.license_plate?.trim() || null;
      payload.document_type = payload.document_type?.trim() || 'CC';

      if (this.isClient) {
        delete payload.password;
        delete payload.password_confirmation;

        if (!payload.email?.trim()) {
          payload.email = this.generateRandomClientEmail();
        }
        if (!payload.phone?.trim()) {
          payload.phone = payload.document?.trim() || '3000000000';
        }
      }

      return payload;
    },
    validateBeforeSave() {
      if (this.isClient) {
        if (!this.user.name?.trim()) {
          Swal.fire('Error', 'El nombre es obligatorio.', 'error');
          return false;
        }
        if (!this.user.document_type || !this.user.document?.trim()) {
          Swal.fire('Error', 'Tipo y número de documento son obligatorios para clientes.', 'error');
          return false;
        }
        return true;
      }

      if (!this.user.name?.trim()) {
        Swal.fire('Error', 'El nombre es obligatorio.', 'error');
        return false;
      }
      if (!this.user.email?.trim()) {
        Swal.fire('Error', 'El correo electrónico es obligatorio.', 'error');
        return false;
      }
      if (!this.user.phone?.trim()) {
        Swal.fire('Error', 'El teléfono es obligatorio.', 'error');
        return false;
      }
      if (this.user.id === 0 && !this.user.password) {
        Swal.fire('Error', 'La contraseña es obligatoria.', 'error');
        return false;
      }
      if (this.user.password && this.user.password !== this.user.password_confirmation) {
        Swal.fire('Error', 'Las contraseñas no coinciden.', 'error');
        return false;
      }
      return true;
    },
    formatSaveError(response) {
      const d = response?.data;
      if (!d) return 'No se pudo guardar el usuario.';
      if (typeof d.message === 'string' && d.message.trim()) return d.message.trim();
      if (d.errors && typeof d.errors === 'object') {
        const parts = Object.values(d.errors).flat().filter(Boolean);
        if (parts.length) return parts.join(' ');
      }
      return 'No se pudo guardar el usuario.';
    },
    async save() {
      if (!this.validateBeforeSave()) return;

      try {
        const payload = this.buildSavePayload();
        const response = await this.$store.dispatch("users/save", payload);
        if (response && response.status >= 200 && response.status < 300) {
          const userId = response.data?.id || this.user.id;
          if (this.motorcyclePhotoFile && userId) {
            try {
              await this.uploadMotorcyclePhoto(userId);
            } catch (photoError) {
              console.error('Error uploading motorcycle photo:', photoError);
              await Swal.fire({
                icon: 'warning',
                title: 'Usuario guardado',
                text: 'El usuario se guardó, pero no se pudo subir la foto de moto.',
              });
              this.$router.push({ name: 'Users' });
              return;
            }
          }

          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El usuario ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                    this.$router.push({ name: 'Users' });
              }
          });
        } else {
          const msg = this.formatSaveError(response);
          await Swal.fire({
            icon: 'error',
            title: 'No se pudo guardar',
            text: msg,
          });
        }
      } catch (error) {
        console.error("Error al crear el usuario:", error);
        const text = error.response
          ? this.formatSaveError(error.response)
          : (error.message || 'Error al guardar el usuario');
        await Swal.fire({
            icon: 'error',
            title: 'No se pudo guardar',
            text,
        });
      }
    }
  },
  mounted() {
    this.getOficios();
    this.loadFromRoute();

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
